import { isBlank } from '../../../../utils/string';

export const formatCatchWeight = (pounds, ounces) => {
  if (isBlank(pounds) && isBlank(ounces)) {
    return null;
  }
  return `${isBlank(pounds) ? 0 : pounds}lb ${isBlank(ounces) ? 0 : ounces}oz`;
};
